import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./InterStateIndividualLicence.module.scss";
import {withRouter} from 'react-router-dom';
import { SpeciesList } from "components/importExport/species/speciesList/SpeciesList";
import { SpeciesForm } from "components/importExport/species/speciesForm/SpeciesForm";
import {Button, ErrorMsg} from "@onegovbugs/onegov-react-components";
import {
    storeSpeciesDetails, 
    saveImportExportApplication, 
    fetchSpecies, 
    clearSpeciesSearch,
    storeSearchSpeciesDetails} from "../../../redux/actions";
import {
    hasAnyValue,
    validate,
    scrollToError,
    isCompleted
  } from "../../../utils/Validation";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  

const InterStateIndividualLicence = props => {

    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);

    const speciesDetails = useSelector(state => state.speciesDetails);
    const licenceDetails = useSelector(state => state.licenceDetails);
    const speciesSearchDetails = useSelector(state => state.speciesSearchDetails);
    const oidc = useSelector(state => state.oidc);

    const dispatch = useDispatch();

    const [isAddSpecies, setIsAddSpecies] = useState(false);
    const [viewMode, setViewMode] = useState("list");
    const [saveMode, setSaveMode] = useState("add");
    const [editRecordNumber, setEditRecordNumber] = useState(null);
    const [editSpecies, setEditSpecies] = useState(null);

    const [searchTextError, setSearchTextError] = useState(speciesSearchDetails ? speciesSearchDetails.searchTextError : null);
  
    // const interStateLicence = useSelector(state => state.interStateLicence);
    const [speciesHistory, setSpeciesHistory] = 
            useState(speciesDetails && speciesDetails.speciesList 
                ? speciesDetails.speciesList.map(on => ({ ...on })) 
                :[]
            );

    const [licenceNumber, setLicenceNumber] = 
        useState(speciesDetails && speciesDetails.licenceNumber 
            ? speciesDetails.licenceNumber
            :''
        );

    const [permitMovementNumber, setPermitMovementNumber] = 
        useState(speciesDetails && speciesDetails.licenceNumber 
            ? speciesDetails.permitMovementNumber
            :''
        );        
        
    const toggleAddSpeciesForm = (isAddSpecies) => {
        
        setIsAddSpecies(!!isAddSpecies);
        if(isAddSpecies)
        {
            setViewMode('form')
        } else {
            setViewMode('list')
        }

        dispatch(clearSpeciesSearch());
    }    

    const saveSpeciesDataHandler = (species) => {
        if (saveMode == "add") {
            setSpeciesHistory([
                ...speciesHistory,
                species
            ]);
          }
        if (saveMode == "edit") {
            speciesHistory[editRecordNumber].atlasId = species.atlasId;
            speciesHistory[editRecordNumber].speciesNoOfFauna = species.speciesNoOfFauna;
            speciesHistory[editRecordNumber].speciesCode = species.speciesCode;
            speciesHistory[editRecordNumber].speciesCommonName = species.speciesCommonName;
            speciesHistory[editRecordNumber].speciesGenus = species.speciesGenus;
            speciesHistory[editRecordNumber].species = species.species;
            speciesHistory[editRecordNumber].subSpecies = species.subSpecies;
            speciesHistory[editRecordNumber].speciesClass = species.speciesClass;
            setSpeciesHistory(speciesHistory);
        }
        setSaveMode("");
        setEditRecordNumber(null);
        dispatch(clearSpeciesSearch());
    }

    const editActionHandler = (itemNumber) => {

        props.history.push(`./interstate-individual-licence/detail/${itemNumber}`);

            // toggleAddSpeciesForm(true);
            // setEditRecordNumber(itemNumber);
            // setSaveMode("edit");
            // setViewMode("form");

            // const editSpecies =             
            //     {
            //         atlasId: speciesHistory[itemNumber].atlasId,
            //         speciesCode: speciesHistory[itemNumber].speciesCode,
            //         speciesCommonName: speciesHistory[itemNumber].speciesCommonName,
            //         speciesGenus: speciesHistory[itemNumber].speciesGenus,
            //         species: speciesHistory[itemNumber].species,
            //         subSpecies: speciesHistory[itemNumber].ubSpecies,
            //         speciesNoOfFauna: speciesHistory[itemNumber].speciesNoOfFauna,
            //         speciesClass: speciesHistory[itemNumber].speciesClass,         
            //     };

            // setEditSpecies(editSpecies);   
    }

    const removeActionHandler = (itemNumber) => {
        let values = [...speciesHistory];
        values.splice(itemNumber, 1);
        setSpeciesHistory([...values]);

        const newSpeciesDetails = {
            ...speciesDetails,
            speciesList : [...values]
        }

        dispatch(storeSpeciesDetails(newSpeciesDetails));

    }

    const storeData = (finished) => {
        const speciesDetails = {
            licenceNumber: licenceNumber,
            permitMovementNumber: permitMovementNumber,
            speciesList: speciesHistory,
            step : 1,
            finished: finished
        };

        dispatch(storeSpeciesDetails(speciesDetails));

    };
    
    const [showErrors, setShowErrors] = useState(false);
    const [errors, setErrors] = useState({
        species: false,
        licenceNumber: false
    });
  
    const validators = [
        {
            fieldName: 'species',
            fieldValue: speciesHistory,
            isValid: hasAnyValue
        },   
        {
            fieldName: "licenceNumber",
            fieldValue: licenceNumber,
            isValid: isCompleted
        }     
    ];
 
    const inputSearchHandler = useCallback(
        

      (enteredFilter) => {
            if(enteredFilter && enteredFilter !== '')
            {
                dispatch(fetchSpecies(enteredFilter, licenceDetails.currentLicenceNumber, oidc))
                // validateAddedSpecies();
            } 
            else {
                const newSpeciesSearchDetails = {
                    ...speciesSearchDetails,
                    species : {
                        ...speciesSearchDetails.species,
                        isValid: false
                    }
                    // searchTextError : {
                    //     showError: true,
                    //     errorMessage: 'Invalid Species Code'
                    // }
                }
                dispatch(storeSearchSpeciesDetails(newSpeciesSearchDetails));
            }
        },
      [dispatch]
    );   

    // const inputSearchHandler = (enteredFilter) => {
    //     console.log(enteredFilter);
    // }

    const validateDuplicateSpecies = (speciesCode) => {
        const isSpeciesExists = speciesHistory.filter(x => x.speciesCode === speciesCode)[0] !== undefined;
        if(isSpeciesExists)
        {
            const newSpeciesSearchDetails = {
                ...speciesSearchDetails,
                species : {
                    ...speciesSearchDetails.species,
                    isValid: false
                },
                searchTextError : {
                    showError: true,
                    errorMessage: 'Species has already been added.'
                }
            }
            dispatch(storeSearchSpeciesDetails(newSpeciesSearchDetails));
            return true;
        } 
        // else {
        //     const newSpeciesSearchDetails = {
        //         ...speciesSearchDetails,
        //         searchTextError : null
        //     }
        //     dispatch(storeSearchSpeciesDetails(newSpeciesSearchDetails));
        //     return false;
        // }

    }

    return (
        <div className={styles.mainCont}>
            {!isAddSpecies && (<div className={"row"}>
                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"licenceNumber"}>
                        Licence Number
                    </label>
                    <input
                    maxLength="50"
                    id={"licenceNumber"}
                    className={styles.inputBox}
                    placeholder="Licence Number"
                    value={licenceNumber}
                    onChange={obj => {
                        // setContactPart({ ...contactPart, emailAddress: obj.target.value });
                        setLicenceNumber(obj.target.value)
                    }}
                    />

                    {errors.licenceNumber && showErrors ? (
                        <ErrorMsg
                            className={"ErrorMsg_error"}
                            type={"error"}
                            description={"Licence Number is required."}
                        />
                    ) : null}                         

                </div>
                 

                <div className={"col-12 col-sm-6"}>
                    <label htmlFor={"permitMovementNumber"}>
                        Import/Export Permit or Movement Number (Optional)
                    </label>
                    <input
                    id={"permitMovementNumber"}
                    className={styles.inputBox}
                    placeholder="Import/Export Permit or Movement Number"
                    value={permitMovementNumber}
                    maxLength="50"
                    onChange={obj => {
                        // setContactPart({ ...contactPart, phoneNo: obj.target.value });
                        setPermitMovementNumber(obj.target.value)
                    }}
                    />    

                </div>

            </div>)}


                {viewMode == "list" && (
                    <React.Fragment>
                        <div className={"row"}>            
                            <div className={"col-12"}>
                                <SpeciesList 
                                    props = {props}
                                    speciesHistory = {speciesHistory}
                                    editActionHandler = {editActionHandler}
                                    removeActionHandler = {removeActionHandler}  />
                            </div>                                            
                        </div>
                        <div className={`row ${styles.buttonCont}`}>
                            <div className={`col-12`}>

                                <Button
                                    secondary
                                    onClick={() => {      
                                        
                                        const newSpeciesDetails = {
                                            ...speciesDetails,
                                            licenceNumber: licenceNumber,
                                            permitMovementNumber: permitMovementNumber,
                                        }
                                
                                        dispatch(storeSpeciesDetails(newSpeciesDetails));
                                
                                        
                                        dispatch(clearSpeciesSearch());
                                        props.history.push(`./interstate-individual-licence/detail`);           
                                    }}
                                >
                                    Add Species
                                </Button>

                                {/* <Button secondary onClick={() => {
                                    setShowErrors(false);
                                    setEditSpecies(null);
                                    setSaveMode("add"); 
                                    setViewMode("form");
                                    toggleAddSpeciesForm(true);
                                }}>
                                    Add Species
                                </Button> */}
                            </div>
                        </div>                                           



                    </React.Fragment>

                )}

                {viewMode == "form" && 
                    (
                        <SpeciesForm 
                            props = {props} 
                            toggleAddSpeciesForm={toggleAddSpeciesForm}
                            saveSpeciesDataHandler = {saveSpeciesDataHandler}
                            editSpecies = {editSpecies}
                            inputSearchHandler = {inputSearchHandler}
                            speciesSearchDetails = {speciesSearchDetails}
                            searchTextError = {searchTextError}
                            validateDuplicateSpecies = {validateDuplicateSpecies}
                        />
                    )
                }



            {errors.species && showErrors ?
            <div className='row'>
                <div className={`col-12`}>
                    <ErrorMsg
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={'There is no species in the list.'}
                    />
                </div>    
            </div>: null }   
                        
            {!isAddSpecies && (
                
                <div className={`row ${styles.buttonCont}`}>                   
                        <div className={`col-12`}>
                            <Button
                                onClick={() => {

                                    if (validate(validators, setErrors)) {
                                        storeData(true);
                                        setShowErrors(false);
                                        dispatch(
                                            saveImportExportApplication("", () => {
                                                props.history.push(`./dashboard`);
                                            })
                                        );
                                    } else {
                                        setShowErrors(true);
                                        scrollToError();
                                    }                                     


                                    // if (validate(validatorsOtherNames, setErrorsOtherNames) && validate(validators, setErrors)) {
                                    //   props.history.push(`./employment`);
                                    //   setShowErrors(false);
                                    //   setShowErrorsOtherNames(false);
                                    //   storeData();
                                    // } else {
                                    //   setShowErrors(true);
                                    //   setShowErrorsOtherNames(true);
                                    //   scrollToError();
                                    // }
                                }}
                            >
                                Continue
                            </Button>

                            <Button
                                secondary
                                onClick={() => {
                                    storeData();
                                    dispatch(
                                        saveImportExportApplication("", () => {
                                            props.history.push(`./dashboard`);
                                        })
                                    );
                                }}
                            >
                                Save & exit section
                            </Button>

                        </div>
                    </div>
                )}

        </div>
    );
};

export default withRouter(props => <InterStateIndividualLicence {...props} />);
